import type { EditionReleaseV1 } from './schemas/edition.js';
import { EditionReleaseV1Schema } from './schemas/edition.js';

export const DEFAULT_PREVIEW_RELEASE: EditionReleaseV1 = EditionReleaseV1Schema.parse({
  schemaVersion: 1,
  releaseId: 'release-preview-1',
  version: 1,
  publishedAt: '2027-06-01T10:00:00+02:00',
  contentHash: '9d0b5a34fe24ba84649337c77c7627ceccdfb8e8ff7c98e47d7e352875c169e1',
  edition: {
    id: 'edition-preview-2027',
    title: {
      de: 'LIR Vorschau 2027',
      en: 'LIR Preview 2027',
    },
    type: 'summer',
    startsAt: '2027-08-05T12:00:00+02:00',
    endsAt: '2027-08-09T12:00:00+02:00',
    arrivalStartsAt: '2027-08-04T12:00:00+02:00',
    timezone: 'Europe/Prague',
  },
  stages: [
    {
      id: 'stage-forest',
      name: { de: 'Waldbühne', en: 'Forest Stage' },
      shortName: 'Forest',
      color: '#7CCB7A',
      mapFeatureId: 'feature-stage-forest',
    },
    {
      id: 'stage-lake',
      name: { de: 'Seebühne', en: 'Lake Stage' },
      shortName: 'Lake',
      color: '#68B8E8',
      mapFeatureId: 'feature-stage-lake',
    },
  ],
  timetable: [
    {
      id: 'act-aurora-echo',
      title: { de: 'Aurora Echo' },
      stageId: 'stage-forest',
      startsAt: '2027-08-06T18:00:00+02:00',
      endsAt: '2027-08-06T19:15:00+02:00',
      tags: ['electronic', 'live'],
    },
    {
      id: 'act-moss-circuit',
      title: { de: 'Moss Circuit' },
      stageId: 'stage-lake',
      startsAt: '2027-08-06T19:00:00+02:00',
      endsAt: '2027-08-06T20:15:00+02:00',
      tags: ['ambient'],
    },
    {
      id: 'act-night-orbit',
      title: { de: 'Night Orbit' },
      stageId: 'stage-forest',
      startsAt: '2027-08-06T20:15:00+02:00',
      endsAt: '2027-08-06T21:30:00+02:00',
      tags: ['house'],
    },
  ],
  map: {
    schemaVersion: 1,
    categories: [
      { id: 'category-stage', label: { de: 'Bühnen', en: 'Stages' }, color: '#D7FF4A', icon: 'music' },
      {
        id: 'category-essential',
        label: { de: 'Wichtig', en: 'Essentials' },
        color: '#F4C95D',
        icon: 'water',
      },
      { id: 'category-path', label: { de: 'Wege', en: 'Paths' }, color: '#CBC7B8', icon: 'route' },
    ],
    features: {
      type: 'FeatureCollection',
      features: [
        {
          type: 'Feature',
          id: 'feature-stage-forest',
          geometry: { type: 'Point', coordinates: [15.331, 50.662] },
          properties: {
            id: 'feature-stage-forest',
            kind: 'stage',
            label: { de: 'Waldbühne', en: 'Forest Stage' },
            categoryId: 'category-stage',
            stageId: 'stage-forest',
          },
        },
        {
          type: 'Feature',
          id: 'feature-stage-lake',
          geometry: { type: 'Point', coordinates: [15.333, 50.663] },
          properties: {
            id: 'feature-stage-lake',
            kind: 'stage',
            label: { de: 'Seebühne', en: 'Lake Stage' },
            categoryId: 'category-stage',
            stageId: 'stage-lake',
          },
        },
        {
          type: 'Feature',
          id: 'feature-water',
          geometry: { type: 'Point', coordinates: [15.332, 50.6625] },
          properties: {
            id: 'feature-water',
            kind: 'poi',
            label: { de: 'Trinkwasser', en: 'Drinking water' },
            categoryId: 'category-essential',
            accessible: true,
          },
        },
        {
          type: 'Feature',
          id: 'feature-main-path',
          geometry: {
            type: 'LineString',
            coordinates: [
              [15.331, 50.662],
              [15.332, 50.6625],
              [15.333, 50.663],
            ],
          },
          properties: {
            id: 'feature-main-path',
            kind: 'path',
            label: { de: 'Hauptweg', en: 'Main path' },
            categoryId: 'category-path',
            accessible: true,
          },
        },
      ],
    },
    routing: {
      nodes: [
        { id: 'node-forest', position: [15.331, 50.662], mapFeatureId: 'feature-stage-forest' },
        { id: 'node-water', position: [15.332, 50.6625], mapFeatureId: 'feature-water' },
        { id: 'node-lake', position: [15.333, 50.663], mapFeatureId: 'feature-stage-lake' },
      ],
      edges: [
        {
          id: 'edge-forest-water',
          fromNodeId: 'node-forest',
          toNodeId: 'node-water',
          distanceMeters: 90,
          geometry: {
            type: 'LineString',
            coordinates: [
              [15.331, 50.662],
              [15.332, 50.6625],
            ],
          },
          bidirectional: true,
          accessible: true,
        },
        {
          id: 'edge-water-lake',
          fromNodeId: 'node-water',
          toNodeId: 'node-lake',
          distanceMeters: 90,
          geometry: {
            type: 'LineString',
            coordinates: [
              [15.332, 50.6625],
              [15.333, 50.663],
            ],
          },
          bidirectional: true,
          accessible: true,
        },
      ],
    },
    initialView: {
      center: [15.332, 50.6625],
      zoom: 16,
      minZoom: 13,
      maxZoom: 20,
    },
  },
});
